
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {getConfig, addDomain, deleteDomain} from '@/services/api';
  import store from "@/store";
  import {MessageBoxData} from "element-ui/types/message-box";

  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class DomainList extends Vue {
    // 控制列表高度
    public tableHeight = window.innerHeight - 150;
    // 域名列表
    public domainList: {domain: string, pixel: string, path: string}[] = []

    /**
     * 初始化方法
     */
    async created(): Promise<void> {
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 150;
        } catch (e) {}
      }
      this.getConfig();
    }

    getConfig(): void {
      getConfig({type: 'domain'}, true).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.domainList = res.data.result || [];
          store.commit('SET_DOMAIN', this.domainList);
        }
      })
    }

    async deleteDomain(domain: string): Promise<void> {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        await deleteDomain({domain}, true);
        this.getConfig();
      }).catch(()=>{});
    }

    async addDomain() {
      this.$prompt('请输入域名', '新增域名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async(res: any) => {
        await addDomain({domain: res.value}, true);
        this.getConfig();
      }).catch(()=>{});
    }
  }

